import { render, staticRenderFns } from "./GeneralStats.vue?vue&type=template&id=83a5915c&"
import script from "./GeneralStats.vue?vue&type=script&lang=js&"
export * from "./GeneralStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports